export enum CourseLessonTaskStatusEnum{

    Pending = 1,
    Corrected = 2,
}
